import ServiceApi from 'vl-common/src/services/service.api';

export function getAvatar(userId: string) {
  return async () => {
    const ret = await ServiceApi.get(`/avatar`, {
      params: { user_guid: userId }
    });

    return ret.data;
  };
}
